import React, { useEffect, useState } from "react";
import { initialPayments, opCurrency } from "../../../propsType/Payemnts";
import { useForm } from "../../../Hooks/UseForm";
import { validatePayments } from "../../../validations/formValidations";
import bs from "../../../assets/svg/bolivares.svg";
import ds from "../../../assets/svg/servicios/divisa.svg";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { UseContextApp } from "../../../Global/Context/appContext";

function Step1(
 
  { 
    stapsState, setStapsState, deatils, stespData, setStespData }
  ) 
  {

  const { form, setForm, errors, handleChange, handleSubmit, handleBlur } =
    useForm(initialPayments, validatePayments, stespData, setStespData);

  const [errorCurrency, setErrorCurrency] = useState(false);
  const [validateState, setValidateState] = useState(false);
  const [{ user }] = UseContextApp();

  const siguiente = () => {
 
    if (form.payments === "" && !stespData.data) {
      setErrorCurrency(true);
    } else if (form.payments.id || stespData?.data?.id) {
      setErrorCurrency(false);
      if (stespData.back) {
        setStespData({
          ...stespData,
          data: form.payments || stespData.data,
        });
        setStapsState({
          ...stapsState,
          option1: false,
          option2: true,
          option3: false,
          option4: false,
          option5: false,
        });
      } else {
        if (!errorCurrency) {
          setStespData({ data: form.payments });
          setStapsState({
            ...stapsState,
            option1: false,
            option2: true,
            option3: false,
            option4: false,
          });
        }
      }
    }
  };
  const changePayment = (value) => {
    switch (value)
    {
      case 1:
        setStespData({
          data: {
            id: 1,
            title: "Dólares",
            logo: ds,
          },
        });
        setTimeout(() => {
          setStapsState({
            ...stapsState,
            option1: false,
            option2: true,
            option3: false,
            option4: false,
            option5: false,
          });
        }, 700);
        break;
      case 2:
        setStespData({
          data: {
            id: 2,
            title: "Bolívares",
            logo: bs,
          },
        });
  
        setTimeout(() => {
          setStapsState({
            ...stapsState,
            option1: false,
            option2: true,
            option3: false,
            option4: false,
            option5: false,
          });
        }, 700);
        break;
    }

  };

  return (

    <>
      <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
        <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
          <div className="ml-4 mt-4">
            <h3 className="text-2xl leading-6 font-medium text-gray-900">
              Moneda
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              Haz clic en la moneda con la que deseas pagar
            </p>
          </div>
        </div>
      </div>
      <div className="lg:p-[60px] w-full">
        <div className="flex justify-center flex-col md:flex-row items-center gap-5 ">
          <button
            onClick={() => changePayment(1)}
            className={`
                          w-full
                          justify-center 
                          items-center 
                          ${stespData?.data?.id === 1
                            ? "border-[#5ab9e5] border-[2px]  "
                            : "border-gray-300 "
                          }
                        h-[162px] 
                        flex-col  
                        relative
                        bg-white 
                        border 
                        rounded-lg
                        hover:border-[#5ab9e5] 
                        lg:w-[30%]    
                        transition-all
                        duration-500 shadow-sm p-4 flex cursor-pointer focus:outline-none`
                      }
          >
            {stespData?.data?.id === 1 && (
              <CheckCircleIcon
                className="h-7 w-7 absolute right-0 top-0 pt-1 pr-1 text-[#5ab9e5]  "
                aria-hidden="true"
              />
            )}

            <img className=" w-[80px] " src={ds} alt="" />
            <div>Dólares </div>
          </button>

         
          {(user?.datos?.codTipoCliente === "1") || (user?.datos?.codTipoCliente === "2" && deatils?.gestion_divisa === "2")?(
             <button
            onClick={() => changePayment(2)}
            //disabled = { user?.datos?.codTipoCliente === "2" && deatils?.gestion_divisa === "2" ? true : false}
            className={`
            w-full
          justify-center 
        items-center 
        ${stespData?.data?.id === 2
                ? "border-[#5ab9e5] border-[2px]  "
                : "border-gray-300 "
              }
        h-[162px] 
        flex-col  
        relative
         bg-white 
         border 
         rounded-lg
          hover:border-[#5ab9e5] 
          lg:w-[30%]    
           transition-all
            duration-500 shadow-sm p-4 flex cursor-pointer focus:outline-none`}
          >
            {stespData?.data?.id === 2 && (
              <CheckCircleIcon
                className="h-7 w-7 absolute right-0 top-0 pt-1 pr-1 text-[#5ab9e5]  "
                aria-hidden="true"
              />
            )}
            <img className=" w-[80px] " src={bs} alt="" />
            <div>Bolívares</div>
          </button>): <div></div>}
        </div>
      </div>
    </>
  );
}

export default Step1;
